var React = require('react');

function MenuCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z"}));
}

MenuCircle.defaultProps = {"viewBox":"0 0 9 10","fill":"none"};

module.exports = MenuCircle;

MenuCircle.default = MenuCircle;
